<template>
	<app-modal modal-alignment="top" modal-body-class="quick-view-modal" modal-id="quickViewModal"
	           modal-size="lg" @close-modal="closeModal">
		<template slot="header">
			<div class="d-flex align-items-center justify-content-between w-100">
				<div>
					<a :class="{ disabled: noMorePrevious }"
					   href=""
					   @click.prevent="Navigation('previous')">
						<app-icon :name="'chevron-left'"></app-icon>
					</a>
					<a :class="{ disabled: noMoreNext }"
					   href=""
					   @click.prevent="Navigation('next')">
						<app-icon :name="'chevron-right'"></app-icon>
					</a>
				</div>

				<div class="d-flex align-items-center">
                    <span class="mr-3 text-secondary"
                    ><app-icon :name="'user'"></app-icon
                    ></span>
					<span class="mt-1">{{ name }}</span>
				</div>

				<button
					aria-label="Close"
					class="close outline-none m-0 p-0"
					data-dismiss="modal"
					type="button">
					<span><app-icon :name="'x'"></app-icon></span>
				</button>
			</div>
		</template>

		<app-overlay-loader v-if="!loader"/>
		<template v-else slot="body">
		

			<div class="row">
				<div class="col-12">

					<app-details-information-frund
						class="mb-primary"
						:details-data="formData"
						:details-sync-url="`crm/frunds/${this.formData.id}`"
						@update-request="updateRequest"/>
						
							
			
					<component is="app-user-info-details-frund"
						:user-info-sync-url="`crm/frunds/profile-picture/${formData.id}`"
						:user-info-data="formData"
                 		component-type="frund"
                 	@update-request="updateRequest"/>
					



          <component is="app-details-deals"
                     :Deals="formData.deals"
                     :contact-list="peopleList"
                     :Id="formData.id"
                     :total-deal="formData.total_deals"
                     component-type="frund"
                     class="mb-primary"
                     :quick-view="true"
                     @viewAllDeal="viewAllDeal"
          />

					

		
				</div>

	
			</div>
		</template>

		<app-deal-modal
			v-if="isDealModalActive"
			:pipeline-id="pipelineId"
			:pre-selected-option="{'frund_id':formData.id}"
      component-type="frund"
      :selectedUrlId="formData.id"
			@close-modal="closeDealModal"
		/>
	</app-modal>
</template>

<script>
import {FormMixin} from "@core/mixins/form/FormMixin.js";
import {formatDateToLocal, onlyTime, onlyTimeFromTime, textTruncate, urlGenerator} from "@app/Helpers/helpers"
import ActivityMixin from "@app/Mixins/Global/ActivityMixin";
import {collect} from "@app/Helpers/Collection";

export default {
  props: ["selectedUrl"],
	name: "FrundQuickViewModal",
	mixins: [FormMixin, ActivityMixin],
	components: {
		"tags-frund": require("./Details/TagsFrund").default,
	},
	data() {
		return {
			formData: {},
			profile_picture: "",
			isDealModalActive: false,
			preLoader: false,
			name: "",
			formatDateToLocal,
			onlyTime,
			onlyTimeFromTime,
			textTruncate,
			urlGenerator,
			noMoreNext: null,
			noMorePrevious: null,
			loader: false,
			isComponent: true,
			appTapShow: false,
			frundActivitiesModal: false,
			activitiesList: [],
			isfileNoteFilter: true,
			// Tab Start
			todoActivityTab: [
				{
					name: "activity",
					icon: "activity",
					component: "common-activity-tab",
					props: "",
					permission: "",
				},
				{
					name: "file",
					icon: "paperclip",
					component: "common-file-tab",
					props: "",
					permission: "",
				},
				{
					name: "note",
					icon: "file-text",
					component: "common-note-tab",
					props: "",
					permission: "",
				},
			],

		};
	},
	computed: {
		peopleList() {
			return this.$store.getters.getFrund
		},
		organizationList() {
			return this.$store.getters.getOrganization
		},
		pipelineId() {
			let allPipeline = this.$store.getters.getPipeline;
			return collect(allPipeline).first().id;
		},
	},
	methods: {
		setTabProps() {
			this.todoActivityTab.forEach((el) => {
				el["props"] = {
					id: this.formData.id,
					frund: "frund",
					contextable_type: "App\\Models\\CRM\\Frund\\Frund",
					activitySyncUrl: `crm/frund/activities/sync/${this.formData.id}`,
					fileSyncUrl: `crm/frund/file/sync/${this.formData.id}`,
					noteSyncUrl: `crm/frund/note/sync/${this.formData.id}`,
				};
			});
		},
		Navigation(parm) {
			this.loader = false;
			if (parm == "next" && !this.noMoreNext) {
				this.axiosGet(
					`crm/frund/navigation-change/${
						this.formData.id
					}${"?parm="}${parm}`
				)
					.then(response => {
						this.formData = response.data.current;
						this.noMoreNext = response.data.noMoreNext;
						this.noMorePrevious = response.data.noMorePrevious;
						this.name = this.formData.name;
						this.loader = true;
						this.setTabProps();
					})
					.catch(({error}) => {
						this.loader = false;
					});
			} else if (!this.noMorePrevious) {
				this.axiosGet(
					`crm/frund/navigation-change/${
						this.formData.id
					}${"?parm="}${parm}`
				).then(response => {
					this.formData = response.data.current;
					this.noMoreNext = response.data.noMoreNext;
					this.noMorePrevious = response.data.noMorePrevious;
					this.name = this.formData.name;
					this.loader = true;
					this.setTabProps();
				})
					.catch(({error}) => {
						this.loader = false;
					});
			}
		},
		submitData() {
			this.save(this.formData);
		},

		afterError(response) {
			this.$toastr.e(response.data.message);
		},

		afterSuccess(response) {
			this.$toastr.s(response.data.message);
		},

		afterFinalResponse() {
			this.closeModal();
		},

		afterSuccessFromGetEditData(response) {
			this.formData = response.data.current;
			this.name = this.formData.name;
			this.setTabProps();
			this.appTapShow = true;
			this.dataLoaded = true;
			this.noMorePrevious = response.data.noMorePrevious;
			this.noMoreNext = response.data.noMoreNext;
			this.loader = true;
		},
		editActivity(activity) {
			this.$emit("openActivityModal", activity);
		},
		updateRequest() {
			this.isComponent = false;
			this.axiosGet(this.selectedUrl).then((response) => {
				this.formData = response.data.current;
				this.name = this.formData.name;
				this.isComponent = true;
			}).catch((error) => console.log(error))
		},

		updateDealList() {
			this.$hub.$on('deal-update-list', (value = true) => {
				if (value) {
					this.updateRequest();
				}
			})
		},
		updateTagList() {
			this.$hub.$on('tag-list', (value = true) => {
				if (value) {
					this.updateRequest();
				}
			})

		},

		closeModal(value) {
			this.$emit("close-modal", value);
		},
		viewAllDeal(frundId) {
			this.$emit("viewAllDeal", frundId)
		},
		viewAllFollower(followerData) {
			this.$emit("viewAllFollower", followerData)
		},
		openDealModal() {
			this.isDealModalActive = true;
			setTimeout(function () {
				$("#deal-modal").modal("show");
			});
		},
		closeDealModal() {
			this.isDealModalActive = false;
			$("#deal-modal").modal("hide");
		},
		editNote(activity) {
			this.$emit("editNote", activity)
		},
	},
	mounted() {
		this.$store.dispatch("getPipeline");
		this.$store.dispatch('getFrund');
		this.updateTagList();
		this.updateDealList();
		$("#deal-modal").on("hidden.bs.modal", () => {
			this.isDealModalActive = false;
		});
	}
};
</script>
<style scoped>
a.disabled {
	opacity: 0.5;
}

.modal-body {

}
</style>
